/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 5d3d2bc2 (Tue Dec 30 16:20:46 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface OK1
 */
export interface OK1 {
  /**
   *
   * @type Error
   * @memberof OK1
   */
  warning?: Error
}

export function OK1FromJSON(json: any): OK1 {
  return OK1FromJSONTyped(json, false)
}

export function OK1FromJSONTyped(json: any, ignoreDiscriminator: boolean): OK1 {
  if (json === undefined || json === null) {
    return json
  }
  return {
    warning: !exists(json, 'warning') ? undefined : json['warning'],
  }
}

export function OK1ToJSON(value?: OK1 | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    warning: value.warning,
  }
}
